import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { UnassignedUnscheduledTask } from "./types";
import { GridColDef } from "@mui/x-data-grid-pro";

interface UnassignedTasksSectionProps {
  tasks: UnassignedUnscheduledTask[];
  columns: GridColDef[];
  isLoading: boolean;
  hasUsers: boolean;
}

export const UnassignedTasksSection: React.FC<UnassignedTasksSectionProps> = ({
  tasks,
  columns,
  isLoading,
  hasUsers,
}) => {
  if (tasks.length === 0) return null;

  return (
    <Box
      sx={{
        borderTop: hasUsers ? "1px solid #E5E7EB" : "none",
        mt: hasUsers ? 2 : 0,
      }}
    >
      <Accordion defaultExpanded={true}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="unassigned-unscheduled-content"
          id="unassigned-unscheduled-header"
          sx={{
            bgcolor: "#F9FAFB",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Unassigned & Unscheduled Tasks ({tasks.length})
            {tasks.some((t) => t.isOverdue || t.isOutOfSprint) && (
              <Chip
                size="small"
                label={`${
                  tasks.filter((t) => t.isOverdue || t.isOutOfSprint).length
                } with date issues`}
                sx={{
                  ml: 1,
                  height: 20,
                  fontSize: 10,
                  bgcolor: "#DC2626",
                  color: "white",
                }}
              />
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <Box sx={{ height: 500, width: "100%", overflowX: "auto" }}>
            <DataGridPro
              rows={tasks}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              disableSelectionOnClick
              disableColumnMenu
              density="compact"
              loading={isLoading}
              sx={{
                border: "none",
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                },
                "& .MuiDataGrid-columnHeaders": {
                  bgcolor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                },
                "& .MuiDataGrid-row:hover": {
                  bgcolor: "#f5f5f5",
                },
                "& .MuiDataGrid-row": {
                  '&[data-has-date-issue="true"]': {
                    bgcolor: "#FEF2F2",
                    "&:hover": {
                      bgcolor: "#FEE2E2",
                    },
                  },
                },
              }}
              getRowClassName={(params) =>
                params.row.isOverdue || params.row.isOutOfSprint
                  ? "date-issue-row"
                  : ""
              }
              components={{
                NoRowsOverlay: () => (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      No unassigned or unscheduled tasks
                    </Typography>
                  </Box>
                ),
              }}
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
